// js
import React from 'react';
import PropTypes from 'prop-types';
import ConfiguredItemContributedCorrelationModalItem from './ConfiguredItemContributedCorrelationModalItem';


const ConfiguredItemContributedCorrelationModalCategory = ({ correlationCategory }) => {

  return (
    <div className='configured-item-contributed-correlation-modal__category'>
      <h4>{correlationCategory.title}</h4>
      <ul>
        {correlationCategory.correlations.map((correlation, index) => (
          <ConfiguredItemContributedCorrelationModalItem
            key={index}
            correlation={correlation}
          />
        ))}
      </ul>
    </div>
  );
};

ConfiguredItemContributedCorrelationModalCategory.propTypes = {
  correlationCategory: PropTypes.object.isRequired
};

export default ConfiguredItemContributedCorrelationModalCategory;



// WEBPACK FOOTER //
// ./src/components/sources/ConfiguredItemContributedCorrelationModalCategory.js